import { QuoteBlock } from "./QuoteBlock";

export * from "./QuoteBlock";

export default QuoteBlock;
